import classes from './Spinner.module.css';

const Spinner = (props)=>{
    return <span className={classes.Loader}></span>;
}

export default Spinner;